export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function img(url) {
  if (!url) return "";
  return url.startsWith("http") ? url : `${BACKEND_URL}${url}`;
}

export function mainImage(product) {
  const imgs = product?.images || [];
  return imgs.length ? img(imgs[0].url) : "";
}
